import documentTypeService from '../../../services/documentType/DocumentTypeService';
import collectionMandateService from '../../../services/collectionMandate/MandateService';
import broadcastMandateService from '../../../services/broadcastMandate/MandateService';

function getSelectedPlatformFields(mandateFields, platform) {
  return mandateFields?.[platform]?.fields?.filter(({field}) => field.key !== 'GROUP_NUMBER') || [];
}

function getCollectionMandate(mandateId) {
  return collectionMandateService.getMandateDetails(mandateId)
    .then(mandate => Promise.all([
      documentTypeService.getBySubtypeCodes([mandate.subtypeCode]),
      collectionMandateService.getMandateFieldsBySubtype(mandate.subtypeCode, mandate.thirdPartyGroup)
    ])
      .then(([[documentType], fieldsResponse]) => {
        const fieldsValues = fieldsResponse
          .map(field => ({...field.field, value: mandate.fieldsValues[field.field.key]}));

        return ({...mandate, subtypeName: documentType.name, fieldsValues});
      }));
}

function getBroadcastMandate(mandateId) {
  return Promise.all([
    broadcastMandateService.getMandateDetails(mandateId),
    broadcastMandateService.getMandateFields()
  ]).then(([mandate, fields]) => {
    const fieldsValues = getSelectedPlatformFields(fields, mandate.platform)
      .map(({field}) => ({
        ...field,
        value: mandate.fieldsValues?.[field.key]
      }));

    return {
      ...mandate,
      scope: fields[mandate.platform]?.scope,
      fieldsValues
    };
  });
}

export function getMandateDetails(mandateId, isCollectionMandate) {
  return isCollectionMandate ?
    getCollectionMandate(mandateId) :
    getBroadcastMandate(mandateId);
}
